enum AuthorizedActions {
    DISPUTE = "dispute",
    DECLINE = "decline",
    EDIT = "edit",
    EDIT_AGENT_SIGN_OFF = "editAgentSignoff",
    EDIT_SCORE = "editScore",
    ASSIGN = "assign",
    RELEASE = "release",
}

export default AuthorizedActions;
